import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'notifications', en);
i18next.addResources('fr', 'notifications', fr);

declare global {
  interface RegisteredLocales {
    notifications: typeof en;
  }
}
